import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Dog, Users, Baby } from 'lucide-react';
import { Sheet, SheetContent } from '@/components/ui/sheet';

const nav = [
  { to: '/dogs', label: 'Dogs', icon: Dog },
  { to: '/litters', label: 'Litters', icon: Baby },
  { to: '/users', label: 'Users', icon: Users },
];

interface SidebarContentProps {
  onLinkClick?: () => void;
}

function SidebarContent({ onLinkClick }: SidebarContentProps) {
  const { pathname } = useLocation();
  return (
    <>
      <div className="flex h-14 items-center px-4" />
      <nav className="grid gap-1 p-2" aria-label="Main navigation">
        {nav.map((item) => {
          const Icon = item.icon;
          const active = pathname === item.to;
          const linkContent = (
            <>
              <Icon className="h-4 w-4" />
              {item.label}
            </>
          );
          return (
            <Link
              key={item.to}
              to={item.to}
              onClick={onLinkClick}
              className={cn(
                'flex items-center gap-2 rounded-md px-3 py-2 text-sm',
                active
                  ? 'bg-background font-medium text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground',
              )}
              aria-current={active ? 'page' : undefined}
            >
              {linkContent}
            </Link>
          );
        })}
      </nav>
    </>
  );
}

interface SidebarProps {
  mobile?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function Sidebar({ mobile = false, open, onOpenChange }: SidebarProps) {
  const handleLinkClick = () => {
    if (mobile && onOpenChange) {
      onOpenChange(false);
    }
  };

  if (mobile) {
    return (
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent side="left" className="w-[220px] p-0">
          <aside className="h-full border-r bg-muted/30">
            <SidebarContent onLinkClick={handleLinkClick} />
          </aside>
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <aside className="hidden border-r bg-muted/30 md:block">
      <SidebarContent />
    </aside>
  );
}
